const viewportReducer = (state={
    width: window.innerWidth,
    height: window.innerHeight,
    latitude: 0,
    longitude: 0,
    mapboxApiAccessToken: 'pk.eyJ1IjoiYXJhdmluZDc0MSIsImEiOiJjaWtkbnBhMnkwMDI0dXZsemNkcmZ6aTFhIn0.aFH5C34Q-iRjYUrx_nHofw',
    zoom: 12
  }, action) => {
    switch(action.type) {
        case "CHANGE_VIEW_PORT": {
            return {...state, ...action.payload}
        }
        default: {
            return state
        }
    }
}

export default viewportReducer



// WEBPACK FOOTER //
// ./src/reducers/viewportReducer.js